import { render, staticRenderFns } from "./RestoreEntityVersion.vue?vue&type=template&id=7b4d1a0e&scoped=true"
import script from "./RestoreEntityVersion.vue?vue&type=script&setup=true&lang=ts"
export * from "./RestoreEntityVersion.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RestoreEntityVersion.vue?vue&type=style&index=0&id=7b4d1a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d1a0e",
  null
  
)

export default component.exports